module.exports = __webpack_public_path__ + "02_short_black.7eedd8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_short_black.png
// module id = i0hf
// module chunks = 0